import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as modle from './module.js';
import recipeView from './view/recipeView.js';
import searchView from './view/searchView.js';
import previewView from './view/previewView.js';
import bookMarkView from './view/bookMarkView.js';

import icons from 'url:../img/icons.svg';
import { async } from 'regenerator-runtime';
import Pagination from './view/paginationView.js';

// https://forkify-api.herokuapp.com/v2

///////////////////////////////////////
// if (module.hot) {
//   module.hot.accept();
// }

const recipeControler = async function () {
  try {
    //welcome message

    // loading spinner

    //getting id from navigator
    let id = window.location.hash.slice(1);
    if (!id) return;
    recipeView.loadingSpinner();

    //update preview view and add active preview

    previewView.update(modle.resultPerPage());
    //update bookMark
    bookMarkView.update(modle.state.bookMark);

    //fetching recipe
    await modle.loadRecipe(id);

    // rendring recipe
    recipeView.render(modle.state.recipe);
  } catch (err) {
    console.log(err);
    recipeView.showError(`${err}`);
  }
};

//loadSearchResult
const searchResultControler = async function () {
  try {
    previewView.loadingSpinner();
    //get queri
    const queri = searchView.getSearchValue();
    //load queri results
    await modle.loadSearchRecipe(queri);
    //render search Result
    previewView.render(modle.resultPerPage());
    //pagination
    Pagination.render(modle.state.search);
  } catch (err) {
    console.log(err);
    previewView.showError(`${err}`);
  }
};

//controlePagination
const controlePagination = function (goToPage) {
  //render search Result
  previewView.render(modle.resultPerPage(goToPage));
  //pagination
  Pagination.render(modle.state.search);
};

// controlServings
const controleServings = function (updateTo) {
  //update Servings
  modle.updateServings(updateTo);
  //update recipe
  // recipeView.render(modle.state.recipe);
  recipeView.update(modle.state.recipe);
};

//bookMark
const controleBookMark = function () {
  if (!modle.state.recipe.bookMark) modle.addBookMark(modle.state.recipe);
  else modle.deleteBookMark(modle.state.recipe.id);

  recipeView.update(modle.state.recipe);

  //adding bookmarkview
  bookMarkView.render(modle.state.bookMark);
};
//handle Bookmark
const controleBookMarkLoad = function () {
  bookMarkView.render(modle.state.bookMark);
};
//constro add recipe

// lisitening to hash change
const init = function () {
  bookMarkView.addHandlerBookMark(controleBookMarkLoad);
  recipeView.addHandlerRender(recipeControler);
  recipeView.addHandlerUpdateServings(controleServings);
  recipeView.addHandlerBookMark(controleBookMark);
  searchView.addHandelerSearch(searchResultControler);
  Pagination.addHandlerClick(controlePagination);
};
init();
// window.addEventListener('hashchange', getRecipe);
// window.addEventListener('load', getRecipe);
